import type * as React from 'react';
import { memo } from 'react';
import { SETTINGS } from '../../../../../routes';
import Breadcrumbs from '../../../../components/Breadcrumbs';
import { useAppContext } from '../../../../hooks/useAppContext';
import { isAnyAdmin } from '../../../../services/User';

type Props = {
    page: string;
    path?: {
        label: string;
        url: string;
    }[];
};

export const makeBreadrumbPath = ({ path = [], page }: Props) => {
    return [
        {
            label: 'Settings',
            url: SETTINGS,
            prependBaseUrl: true,
        },
        ...path.map(p => ({ ...p, prependBaseUrl: true })),
        { label: page },
    ];
};

const AdminBreadcrumbs: React.FC<Props> = props => {
    const { user } = useAppContext();
    return isAnyAdmin(user) ? <Breadcrumbs path={makeBreadrumbPath(props)} /> : null;
};

export default memo(AdminBreadcrumbs);
